export const BRAND_NAME = 'Play247scom';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN = 'play247s.net';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'play247s.net';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'cue88.com';